module.exports = __webpack_public_path__ + "img/bn.09f380ca.svg";